import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { SefAgreementRequiredTemplate as template } from './sef-agreement-required.template';
import { SefAgreementRequiredStyles as styles } from './sef-agreement-required.styles';
import { ICompanyService } from '../../../services/company.service';
import { logger, Message } from '@genesislcap/foundation-comms';
import { updateArray } from '../../../utils/dataserver';

const name = 'sef-agreement-required';
@customElement({
  name,
  template,
  styles,
})
export class SefAgreementRequired extends FASTElement {
  @ICompanyService companyService: ICompanyService;
  @observable public companies: Array<any> = [];

  connectedCallback() {
    super.connectedCallback();
    this.loadCompanies();
  }

  private async loadCompanies() {
    const currentCompanyObject = {
      NAME: this.companyService.getCurrentCompany().NAME,
      CASCADE_COMPANY_ID: this.companyService.getCurrentCompany().CASCADE_COMPANY_ID,
    };

    this.companyService
      .getMyCompanies(
        `CASCADE_PARENT_COMPANY_ID == '${
          this.companyService.getCurrentCompany().CASCADE_COMPANY_ID
        }' && SEF_PARTICIPANT_AGREEMENT_CONSENT == false`
      )
      .subscribe({
        next: (streamMessage: Message) => {
          const companiesResultList = streamMessage.ROW ?? null;

          if (companiesResultList) {
            this.companies = updateArray(companiesResultList, this.companies);
          }

          if (
            !this.companies.includes(currentCompanyObject) &&
            !this.companyService.getCurrentCompany().SEF_PARTICIPANT_AGREEMENT_CONSENT
          ) {
            this.companies.unshift(currentCompanyObject);
          }
        },
        error: (error: any) => {
          logger.error(error);
        },
      });
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
  }
}
